{
  "familyId": "SPR-LEESTEKEN-PUNT-KOMMA",
  "questions": [
    {
      "id": "SPR-LEESTEKEN-PUNT-KOMMA-001",
      "familyId": "SPR-LEESTEKEN-PUNT-KOMMA",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "leesteken_punt_komma",
      "questionType": "multiple_choice",
      "question": "Welk leesteken hoort op de plek van het streepje?\n\nHoewel het hard regent _ gaan we toch naar buiten om te spelen.",
      "options": ["een komma (,)", "een punt (.)", "een uitroepteken (!)", "een vraagteken (?)"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Komma na een bijzin vooraan", "content": "Als een zin begint met een bijzin (een zin die start met 'hoewel', 'omdat', 'als', 'terwijl' enz.), zet je een komma tussen de bijzin en de hoofdzin. Voorbeeld: 'Hoewel de zon schijnt, is het koud.'", "icon": "lightbulb" } }
      ],
      "conceptId": "leesteken_komma_bijzin_vooraan",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "De zin begint met een bijzin: 'Hoewel het hard regent'. Daarna komt de hoofdzin: 'gaan we toch naar buiten om te spelen'. Tussen een bijzin vooraan en de hoofdzin zet je altijd een komma. Truc: lees de zin hardop, waar je vanzelf even pauzeert, hoort vaak een komma.",
        "solutionSteps": [
          "Herken de bijzin vooraan: 'Hoewel het hard regent'",
          "Daarna komt de hoofdzin: 'gaan we toch naar buiten...'",
          "Tussen bijzin vooraan en hoofdzin → altijd een komma"
        ],
        "distractorExplanations": {
          "0": "Goed! Na een bijzin vooraan ('Hoewel het hard regent') komt een komma.",
          "1": "Je dacht waarschijnlijk dat er een punt moest. Maar dan breek je de zin doormidden — de hoofdzin 'gaan we toch naar buiten' kan niet alleen staan zonder de bijzin in deze context. Een komma houdt de zin heel.",
          "2": "Een uitroepteken gebruik je bij verbazing of een bevel, en altijd aan het einde van een zin. Hier zit je middenin de zin.",
          "3": "Een vraagteken gebruik je aan het einde van een vraag. Dit is geen vraag en het is niet het einde van de zin."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.leesteken-punt-ipv-komma", "label": "Kiest punt waar komma past", "optionIndex": 1 },
          { "id": "spr.leesteken-uitroep-verkeerd", "label": "Kiest uitroepteken bij mededeling", "optionIndex": 2 }
        ]
      }
    },
    {
      "id": "SPR-LEESTEKEN-PUNT-KOMMA-002",
      "familyId": "SPR-LEESTEKEN-PUNT-KOMMA",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "leesteken_punt_komma",
      "questionType": "multiple_choice",
      "question": "In welke zin staan de leestekens goed?",
      "options": [
        "Mijn broertje houdt van appels, peren, bananen en druiven.",
        "Mijn broertje houdt van appels peren, bananen, en druiven.",
        "Mijn broertje houdt van, appels, peren, bananen en druiven.",
        "Mijn broertje houdt van appels, peren, bananen, en druiven."
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Komma bij opsomming", "content": "Bij een opsomming zet je een komma tussen de woorden, behalve voor het woordje 'en'. Dus: appels, peren en bananen.", "icon": "lightbulb" } }
      ],
      "conceptId": "leesteken_komma_opsomming",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Bij een opsomming zet je een komma tussen elk woord, behalve voor het laatste woord met 'en'. De juiste zin is dus: 'Mijn broertje houdt van appels, peren, bananen en druiven.'",
        "solutionSteps": [
          "Herken de opsomming: appels, peren, bananen, druiven",
          "Zet een komma tussen de woorden: appels, peren, bananen",
          "Zet géén komma voor 'en': bananen en druiven"
        ],
        "distractorExplanations": {
          "0": "Goed! Komma's tussen de woorden, maar géén komma voor 'en'.",
          "1": "Er mist een komma tussen 'appels' en 'peren', en er staat onterecht een komma voor 'en'.",
          "2": "Er staat onterecht een komma na 'van'. De opsomming begint pas bij 'appels'.",
          "3": "Er staat onterecht een komma voor 'en'. Bij een opsomming gebruik je geen komma voor 'en'."
        }
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-LEESTEKEN-PUNT-KOMMA-003",
      "familyId": "SPR-LEESTEKEN-PUNT-KOMMA",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "leesteken_punt_komma",
      "questionType": "multiple_choice",
      "question": "Lees het tekstje. Waar ontbreekt een punt?\n\nDe meester vertelt een spannend verhaal over ridders en kastelen de kinderen luisteren aandachtig naar hem.",
      "options": [
        "Tussen 'verhaal' en 'over'",
        "Tussen 'kastelen' en 'de'",
        "Tussen 'kinderen' en 'luisteren'",
        "Tussen 'aandachtig' en 'naar'"
      ],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Punt aan het einde van een zin", "content": "Elke afgeronde zin eindigt met een punt. Lees de tekst hardop: waar pauzeer je natuurlijk omdat een gedachte af is? Daar hoort een punt.", "icon": "lightbulb" } }
      ],
      "conceptId": "leesteken_punt_missend_tekst",
      "variantIndex": 3,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "De tekst bestaat uit twee aparte zinnen die aan elkaar zijn geplakt. Zin 1: 'De meester vertelt een spannend verhaal over ridders en kastelen.' Zin 2: 'De kinderen luisteren aandachtig naar hem.' Tussen 'kastelen' en 'de' hoort dus een punt.",
        "solutionSteps": [
          "Lees de tekst hardop en zoek waar een gedachte af is.",
          "'De meester vertelt een spannend verhaal over ridders en kastelen' is een volledige zin.",
          "'de kinderen luisteren aandachtig naar hem' is de volgende zin.",
          "Er hoort een punt na 'kastelen'."
        ],
        "distractorExplanations": {
          "0": "Als je hier een punt zet, krijg je: 'De meester vertelt een spannend verhaal. Over ridders en kastelen de kinderen...'. Dat klopt niet.",
          "1": "Goed! Hier eindigt de eerste zin en begint de tweede.",
          "2": "Als je hier een punt zet, breek je de tweede zin doormidden: 'De kinderen. Luisteren aandachtig...'.",
          "3": "Als je hier een punt zet, breek je de tweede zin doormidden: 'De kinderen luisteren aandachtig. Naar hem.'."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.leesteken-punt-ipv-komma", "label": "Punt midden in een zin", "optionIndex": 0 }
        ]
      }
    },
    {
      "id": "SPR-LEESTEKEN-PUNT-KOMMA-004",
      "familyId": "SPR-LEESTEKEN-PUNT-KOMMA",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "leesteken_punt_komma",
      "questionType": "multiple_choice",
      "question": "In welke zin ontbreekt een komma?",
      "options": [
        "Ik wil graag buiten spelen maar het regent te hard.",
        "De grote zwarte hond rent snel door de tuin.",
        "Mijn vader en moeder gaan vanavond naar de bioscoop.",
        "We hebben gisteren een hele leuke film gekeken."
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Komma voor voegwoorden", "content": "Voor voegwoorden zoals 'maar', 'want' en 'omdat' zet je meestal een komma. Voorbeeld: 'Ik ben moe, want ik heb laat op gebleven.'", "icon": "lightbulb" } }
      ],
      "conceptId": "leesteken_komma_voor_maar",
      "variantIndex": 4,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Voor het woordje 'maar' hoort een komma te staan. Het verbindt twee zinnen met een tegenstelling. De juiste zin is: 'Ik wil graag buiten spelen, maar het regent te hard.'",
        "solutionSteps": [
          "Zoek naar voegwoorden zoals 'maar' of 'want'.",
          "In de eerste zin staat 'maar'.",
          "Voor 'maar' hoort een komma: '...spelen, maar...'"
        ],
        "distractorExplanations": {
          "0": "Goed! Voor het woordje 'maar' hoort een komma: '...spelen, maar...'",
          "1": "Deze zin is correct. Er is geen reden voor een komma hier.",
          "2": "Deze zin is correct. Tussen 'vader' en 'moeder' staat 'en', daar hoort geen komma.",
          "3": "Deze zin is correct. Het is één doorlopende zin zonder pauzes of opsommingen."
        }
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-LEESTEKEN-PUNT-KOMMA-005",
      "familyId": "SPR-LEESTEKEN-PUNT-KOMMA",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "leesteken_punt_komma",
      "questionType": "fill_in",
      "question": "Zet het juiste leesteken op de plek van het streepje.\n\nIn mijn tas zitten boeken _ pennen en een liniaal.",
      "correctAnswer": ",",
      "data": {
        "acceptedAnswers": [","],
        "caseSensitive": false,
        "placeholder": "?"
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Komma bij opsomming", "content": "Bij een opsomming zet je een komma tussen de woorden, behalve voor 'en'. Dus: boeken, pennen en een liniaal.", "icon": "lightbulb" } }
      ],
      "conceptId": "leesteken_komma_fill_opsomming",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Dit is een opsomming: boeken, pennen en een liniaal. Na 'boeken' komt een komma, want bij een opsomming zet je een komma tussen de woorden. Voor 'en' komt geen komma.",
        "solutionSteps": [
          "Herken de opsomming: boeken, pennen, liniaal",
          "Zet een komma tussen de woorden: boeken, pennen",
          "Typ een komma (,)"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-LEESTEKEN-PUNT-KOMMA-006",
      "familyId": "SPR-LEESTEKEN-PUNT-KOMMA",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "leesteken_punt_komma",
      "questionType": "error_spotting",
      "question": "Zoek de leestekenfout in deze tekst en verbeter hem.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "Morgen gaan we naar het bos. We nemen broodjes drinken en fruit mee voor de picknick.",
        "errors": [
          {
            "word": "broodjes drinken",
            "position": 5,
            "correction": "broodjes, drinken",
            "explanation": "Bij een opsomming zet je een komma tussen de woorden: broodjes, drinken en fruit."
          }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Komma bij opsomming", "content": "Bij een opsomming zet je een komma tussen de woorden, behalve voor 'en'.\nFout: broodjes drinken en fruit\nGoed: broodjes, drinken en fruit", "icon": "lightbulb" } }
      ],
      "conceptId": "leesteken_komma_error_spotting_opsomming",
      "variantIndex": 6,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Er ontbreekt een komma in de opsomming. Het moet zijn: 'broodjes, drinken en fruit'. Bij een opsomming zet je een komma tussen elk woord, behalve voor 'en'.",
        "solutionSteps": [
          "Lees de tekst en zoek naar een opsomming.",
          "De opsomming is: broodjes, drinken, fruit.",
          "Er mist een komma na 'broodjes'.",
          "Verbetering: broodjes, drinken"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-LEESTEKEN-PUNT-KOMMA-007",
      "familyId": "SPR-LEESTEKEN-PUNT-KOMMA",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "leesteken_punt_komma",
      "questionType": "multiple_choice",
      "question": "In welke zin staan de leestekens goed?",
      "options": [
        "Omdat het koud is, doe ik mijn dikke jas aan.",
        "Omdat het koud is doe ik, mijn dikke jas aan.",
        "Omdat, het koud is doe ik mijn dikke jas aan.",
        "Omdat het koud is doe ik mijn dikke jas, aan."
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Komma na een bijzin", "content": "Als een zin begint met een woord als 'omdat', 'als' of 'hoewel', krijg je eerst een bijzin. Na die bijzin zet je een komma. Voorbeeld: 'Als het regent, blijf ik binnen.'", "icon": "lightbulb" } }
      ],
      "conceptId": "leesteken_komma_bijzin_mc",
      "variantIndex": 7,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "De zin begint met de bijzin 'Omdat het koud is'. Daarna volgt de hoofdzin 'doe ik mijn dikke jas aan'. Tussen deze twee zinsdelen hoort een komma. De juiste zin is dus: 'Omdat het koud is, doe ik mijn dikke jas aan.'",
        "solutionSteps": [
          "Herken de bijzin: 'Omdat het koud is'",
          "Herken de hoofdzin: 'doe ik mijn dikke jas aan'",
          "Zet de komma tussen de bijzin en de hoofdzin."
        ],
        "distractorExplanations": {
          "0": "Goed! De komma staat precies tussen de bijzin en de hoofdzin.",
          "1": "De komma staat verkeerd. 'doe ik' hoort bij de hoofdzin, de komma moet daarvóór.",
          "2": "De komma staat verkeerd. 'Omdat het koud is' is één geheel (de bijzin).",
          "3": "De komma staat verkeerd. 'aan' hoort bij 'doe ik', je mag dat niet scheiden met een komma."
        }
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-LEESTEKEN-PUNT-KOMMA-008",
      "familyId": "SPR-LEESTEKEN-PUNT-KOMMA",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "leesteken_punt_komma",
      "questionType": "error_spotting",
      "question": "Zoek de leestekenfout in deze tekst en verbeter hem.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "Ik wilde gisteren naar het strand gaan maar het begon ineens heel hard te onweren.",
        "errors": [
          {
            "word": "gaan maar",
            "position": 6,
            "correction": "gaan, maar",
            "explanation": "Voor het voegwoord 'maar' zet je een komma."
          }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Komma voor 'maar'", "content": "Voor het woordje 'maar' zet je bijna altijd een komma, omdat het twee zinnen met een tegenstelling verbindt.", "icon": "lightbulb" } }
      ],
      "conceptId": "leesteken_komma_error_spotting_maar",
      "variantIndex": 8,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Voor het woordje 'maar' hoort een komma te staan. Het verbindt twee zinnen. Het moet zijn: '...naar het strand gaan, maar het begon...'",
        "solutionSteps": [
          "Lees de tekst en zoek naar voegwoorden zoals 'maar' of 'want'.",
          "Je ziet het woord 'maar'.",
          "Voor 'maar' hoort een komma.",
          "Verbetering: gaan, maar"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-LEESTEKEN-PUNT-KOMMA-009",
      "familyId": "SPR-LEESTEKEN-PUNT-KOMMA",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "leesteken_punt_komma",
      "questionType": "sentence_error_judge",
      "question": "Beoordeel elke zin: staan de leestekens op de juiste plek?",
      "data": {
        "sentences": [
          { "text": "De meester, kijkt streng naar de klas.", "hasError": true, "correction": "De meester kijkt streng naar de klas.", "explanation": "Tussen het onderwerp (De meester) en de persoonsvorm (kijkt) komt nooit een komma." },
          { "text": "Als je je huiswerk af hebt, mag je op de computer.", "hasError": false },
          { "text": "We kopen slingers, ballonnen en taart voor het feest.", "hasError": false },
          { "text": "Ik ben erg moe, want ik heb slecht geslapen.", "hasError": false }
        ]
      },
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Kommaregels controleren", "content": "Geen komma tussen onderwerp en persoonsvorm. Wel een komma bij een opsomming, na een bijzin vooraan, en vóór 'maar' of 'want'.", "icon": "lightbulb" } }
      ],
      "conceptId": "leesteken_error_judge_context",
      "variantIndex": 9,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Zin 1 is fout: er mag geen komma tussen 'De meester' en 'kijkt'. De zinnen 2 (komma na bijzin), 3 (opsomming) en 4 (komma vóór 'want') hebben de leestekens wél op de juiste plek.",
        "solutionSteps": [
          "Zin 1: komma tussen onderwerp en werkwoord → fout ✗",
          "Zin 2: komma na bijzin vooraan ('Als...') → correct ✓",
          "Zin 3: opsomming met komma en 'en' → correct ✓",
          "Zin 4: komma vóór 'want' → correct ✓"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-LEESTEKEN-PUNT-KOMMA-010",
      "familyId": "SPR-LEESTEKEN-PUNT-KOMMA",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "leesteken_punt_komma",
      "questionType": "multiple_choice",
      "question": "Welk leesteken hoort op de plek van het streepje?\n\nWat een prachtige tekening heb je gemaakt_",
      "options": ["een uitroepteken (!)", "een vraagteken (?)", "een punt (.)", "een komma (,)"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Uitroepteken bij emotie", "content": "Een uitroepteken gebruik je aan het einde van een zin om verbazing, blijdschap, boosheid of een waarschuwing uit te drukken. Voorbeeld: 'Wat mooi!' of 'Pas op!'", "icon": "lightbulb" } }
      ],
      "conceptId": "leesteken_uitroepteken",
      "variantIndex": 10,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "De zin 'Wat een prachtige tekening heb je gemaakt' drukt bewondering of blijdschap uit. Aan het einde van zo'n uitroep gebruik je een uitroepteken (!). Het is geen gewone mededeling (punt) en ook geen vraag (vraagteken).",
        "solutionSteps": [
          "Lees de zin en bepaal de toon: is het een vraag, mededeling of uitroep?",
          "'Wat een prachtige tekening...' is een uitroep van bewondering.",
          "Bij een uitroep hoort een uitroepteken (!)."
        ],
        "distractorExplanations": {
          "0": "Goed! De zin drukt bewondering uit, dus gebruik je een uitroepteken.",
          "1": "Je dacht waarschijnlijk dat het een vraag was omdat het begint met 'Wat'. Maar er wordt geen antwoord verwacht; het is een uitroep van bewondering. Onthoud: niet elke zin met een vraagwoord is een vraag.",
          "2": "Een punt gebruik je bij een gewone mededeling ('Ik heb een tekening gemaakt.'). Deze zin drukt sterke emotie (bewondering) uit, dus hoort er een uitroepteken.",
          "3": "Een komma staat nooit aan het einde van een afgeronde zin. Een zin eindigt altijd met een punt, vraagteken of uitroepteken."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.leesteken-vraag-ipv-uitroep", "label": "Kiest vraagteken bij uitroep met vraagwoord", "optionIndex": 1 }
        ]
      }
    },
    {
      "id": "SPR-LEESTEKEN-PUNT-KOMMA-011",
      "familyId": "SPR-LEESTEKEN-PUNT-KOMMA",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "leesteken_punt_komma",
      "questionType": "multiple_choice",
      "question": "In welke zin staan de leestekens van de directe rede goed?",
      "options": [
        "\"Kom je ook?\" vroeg Tim aan zijn vriend.",
        "\"Kom je ook? vroeg Tim\" aan zijn vriend.",
        "Kom je ook? \"vroeg Tim aan zijn vriend.\"",
        "\"Kom je ook?\", vroeg Tim aan zijn vriend."
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Leestekens bij directe rede", "content": "Wat iemand letterlijk zegt, staat tussen aanhalingstekens. Het leesteken (?, ! of ,) hoort BINNEN de aanhalingstekens. Bij een vraag of uitroep komt er daarna géén extra komma. Voorbeeld: \"Kom je?\" vroeg hij.", "icon": "lightbulb" } }
      ],
      "conceptId": "leesteken_directe_rede",
      "variantIndex": 11,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Bij directe rede staat wat iemand zegt tussen aanhalingstekens, en het vraagteken hoort daar binnenin: \"Kom je ook?\". Omdat de zin al een vraagteken heeft, komt er daarna géén extra komma vóór 'vroeg'. De juiste zin is: \"Kom je ook?\" vroeg Tim aan zijn vriend.",
        "solutionSteps": [
          "Zet wat letterlijk gezegd wordt tussen aanhalingstekens: \"Kom je ook?\"",
          "Het vraagteken hoort binnen de aanhalingstekens.",
          "Na een vraag- of uitroepteken komt geen extra komma vóór 'vroeg'."
        ],
        "distractorExplanations": {
          "0": "Goed! Het vraagteken staat binnen de aanhalingstekens en er volgt geen extra komma.",
          "1": "De aanhalingstekens staan op de verkeerde plekken. Alleen de letterlijk gesproken woorden (\"Kom je ook?\") horen ertussen, niet 'vroeg Tim'.",
          "2": "De aanhalingstekens staan om het verkeerde deel. De gesproken woorden 'Kom je ook?' horen ertussen, niet 'vroeg Tim aan zijn vriend'.",
          "3": "Na een vraagteken komt geen extra komma. Het vraagteken vervangt de komma al: \"Kom je ook?\" vroeg Tim."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.leesteken-aanhaling-verkeerd", "label": "Plaatst aanhalingstekens om het verkeerde zinsdeel", "optionIndex": 1 },
          { "id": "spr.leesteken-dubbele-leesteken", "label": "Zet komma ná een vraag-/uitroepteken in directe rede", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-LEESTEKEN-PUNT-KOMMA-012",
      "familyId": "SPR-LEESTEKEN-PUNT-KOMMA",
      "module": "SpellingRegel",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "leestekens",
      "subSkill": "leesteken_punt_komma",
      "questionType": "multiple_choice",
      "question": "Welk leesteken hoort op de plek van het streepje?\n\nVoor de taart heb je drie dingen nodig _ bloem, suiker en eieren.",
      "options": [
        "een dubbele punt (:)",
        "een komma (,)",
        "een punt (.)",
        "een puntkomma (;)"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Dubbele punt voor een opsomming", "content": "Een dubbele punt (:) gebruik je om aan te kondigen dat er een opsomming of uitleg volgt. Je kunt er vaak 'namelijk' voor lezen. Voorbeeld: 'Ik kocht drie dingen: brood, kaas en melk.'", "icon": "lightbulb" } }
      ],
      "conceptId": "leesteken_dubbele_punt_opsomming",
      "variantIndex": 12,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De zin kondigt een opsomming aan: na 'drie dingen nodig' volgt de lijst 'bloem, suiker en eieren'. Om een opsomming aan te kondigen gebruik je een dubbele punt (:). Truc: je kunt er 'namelijk' voor lezen — 'drie dingen nodig, namelijk bloem, suiker en eieren'.",
        "solutionSteps": [
          "Kijk wat er na het streepje komt: een opsomming (bloem, suiker, eieren).",
          "Een opsomming aankondigen doe je met een dubbele punt (:).",
          "Controleer met 'namelijk': 'drie dingen nodig, namelijk bloem...' → klopt."
        ],
        "distractorExplanations": {
          "0": "Goed! Een dubbele punt kondigt de opsomming aan die erna komt.",
          "1": "Een komma is te zwak om de opsomming aan te kondigen. De komma's komen pas binnen de opsomming zelf: bloem, suiker en eieren.",
          "2": "Een punt sluit de zin af, maar dan staat de opsomming los zonder verband. De zin loopt juist door naar de opsomming.",
          "3": "Een puntkomma (;) scheidt twee gelijkwaardige hoofdzinnen. Hier wordt een opsomming aangekondigd — dat doe je met een dubbele punt."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.leesteken-dubbele-punt-verkeerd", "label": "Kiest komma waar dubbele punt past", "optionIndex": 1 }
        ]
      }
    }
  ]
}